import React from 'react';
import {DomainsCard} from './domainsCard';

export const DomainManagement = () => {
    return <DomainsCard />
}
